import { render, staticRenderFns } from "./ILoader.vue?vue&type=template&id=19db1499"
import script from "./ILoader.vue?vue&type=script&lang=js"
export * from "./ILoader.vue?vue&type=script&lang=js"
import style0 from "./ILoader.vue?vue&type=style&index=0&id=19db1499&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports